export class ItemStepHistoryEmitter {
	itemId: number;
	limitedItemStepId: number;
	actionType: string;

	constructor() {
		this.itemId = -1;
		this.limitedItemStepId = -1;
		this.actionType = "";
	}
}
